import { Link, useLocation } from "react-router-dom";
import { MessageCircle, Map } from "lucide-react";
import { useConciergeNumber } from "../../lib/concierge";

const HIDDEN = [/^\/admin/, /^\/partner/, /^\/account/, /^\/login/];

export default function MobileActionBar() {
    const { pathname } = useLocation();
    const wa = useConciergeNumber();
    if (HIDDEN.some((re) => re.test(pathname))) return null;
    const msg = encodeURIComponent("Hi MyEcoTour — I'd like to plan a journey.");
    return (
        <div
            className="md:hidden fixed bottom-0 inset-x-0 z-[55] grid grid-cols-2 border-t border-white/10 shadow-[0_-4px_20px_rgba(0,0,0,0.25)]"
            style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
            data-testid="mobile-action-bar"
        >
            <a
                href={`https://wa.me/${wa}?text=${msg}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mobile-bar-whatsapp"
                className="flex items-center justify-center gap-2 py-3.5 bg-[#1E3B2C] text-[#F3EFE9] text-[11px] tracking-[0.2em] uppercase font-semibold"
            >
                <MessageCircle size={15} /> WhatsApp
            </a>
            <Link
                to="/contact"
                data-testid="mobile-bar-itinerary"
                className="flex items-center justify-center gap-2 py-3.5 bg-accent text-accent-foreground text-[11px] tracking-[0.2em] uppercase font-semibold"
            >
                <Map size={15} /> Request Itinerary
            </Link>
        </div>
    );
}
